import { Button, Typography, useTheme } from '@mui/material'

import { useCancelSubscription, useRenewSubscription } from 'src/hooks'
import { useStyles } from '../account-support/styles'
import { EAccountSubscriptionPlans } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { useAccountSubscriptionPlanInfo } from 'src/hooks/payments/use-account-subscription-plan-info.hook'

const BillingCancellation = () => {
  const theme = useTheme()
  const classes = useStyles()
  const { mutate: cancel, isLoading: isCancelLoading } = useCancelSubscription()
  const { mutate: renew, isLoading: isRenewLoading } = useRenewSubscription()
  const { data: subscriptionPlanInfo, isLoading: issubScriptionPlanInfoLoading } =
    useAccountSubscriptionPlanInfo()

  const handleCancel = () => cancel()

  const handleRenew = () => renew()

  // if (issubScriptionPlanInfoLoading) {
  //   return null
  // }

  // if (
  //   subscriptionPlanInfo?.expired &&
  //   subscriptionPlanInfo.subscription_plan === EAccountSubscriptionPlans.free
  // ) {
  //   return null
  // }

  return (
    <div className={`${classes.itemBorder} ${classes.cancellationWrapper}`}>
      <h3 className={classes.itemTitle}>
        <HelperWrapper
          t={
            subscriptionPlanInfo?.subscription_cancelled
              ? 'subscription-renew-button'
              : 'subscription-cancel-button'
          }
        />
        {subscriptionPlanInfo?.expired && subscriptionPlanInfo?.expiered_plan && (
          <Typography
            sx={{
              position: 'absolute',
              top: '-5px',
              right: '0px',
              fontStyle: 'italic',
              transform: 'translateX(105%)',
              fontSize: '12px',
              fontWeight: 700,
              color: theme.palette.custom.warning2,
            }}
          >
            Expired
          </Typography>
        )}
      </h3>
      <Button
        disabled={
          (isRenewLoading ||
            isCancelLoading ||
            issubScriptionPlanInfoLoading ||
            subscriptionPlanInfo?.subscription_plan === EAccountSubscriptionPlans.free) ??
          true
        }
        onClick={subscriptionPlanInfo?.subscription_cancelled ? handleRenew : handleCancel}
        variant="contained"
        className={`${classes.cancellationButton} ${
          subscriptionPlanInfo?.subscription_cancelled
            ? classes.cancellationButtonGreen
            : classes.cancellationButtonRed
        }`}
      >
        <HelperWrapper
          t={
            subscriptionPlanInfo?.subscription_cancelled
              ? 'subscription-renew-button'
              : 'subscription-cancel-button'
          }
        />
      </Button>
    </div>
  )
}

export { BillingCancellation }
